/* ============================================================
   SHILPKALA — DISABLE NATIVE VIDEO CONTROLS
   ============================================================ */

(() => {
  const VIDEO_SELECTOR = 'deferred-media video';

  /**
   * Remove native browser controls from a video.
   */
  function disableVideoControls(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.removeAttribute('controls');
    video.controls = false;
  }

  /**
   * Process videos inside a given DOM scope.
   */
  function processVideos(root = document) {
    if (
      root instanceof HTMLVideoElement &&
      root.matches(VIDEO_SELECTOR)
    ) {
      disableVideoControls(root);
      return;
    }

    if (!root.querySelectorAll) return;

    root
      .querySelectorAll(VIDEO_SELECTOR)
      .forEach(disableVideoControls);
  }

  /**
   * Existing videos.
   */
  processVideos();


  /**
   * Horizon's deferred-media component can inject
   * the actual <video> after initial page load.
   *
   * Watch for those dynamically inserted videos.
   */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        processVideos(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();